<template>
  <v-app>
    <v-app-bar app dark color="#212121">
      <img :height="skin.headerLogoSize" :src="require(`@/assets/${skin.headerLogo}`)" :alt="skin.name" class="pl-2 pr-2">
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main style="max-width: 1280px;">
      <model-report-component v-if="shareParams.clientObject" :share-params="shareParams"></model-report-component>
      <div v-else>{{ $t('views.SharedModelReport.loading') }}</div>
    </v-main>
    <div style="text-align: center; padding-top: 40px;">
      <img v-if="skin.footerLogo" :height="skin.footerHeight" :src="require(`@/assets/${skin.footerLogo}`)">
    </div>
  </v-app>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ModelReportComponent from '@/components/ModelReportComponent.vue'
export default {
  name: 'SharedModelReport',
  data: () => ({}),
  methods: {
    ...mapActions('shared', [
      'getSharedModelReport'
    ])
  },
  computed: {
    ...mapGetters('shared', [
      'modelReportClientId',
      'modelReportClientObject'
    ]),
    shareParams () {
      return {
        clientId: this.modelReportClientId,
        clientObject: this.modelReportClientObject
      }
    },
    skin () {
      // Duplicated in App.vue, Home.vue, and for model_status functionality
      // Also present in SharedPlan.vue
      // TODO: Unify
      if (window.location.hostname === 'predixon.noisegrasp.com') {
        return {
          name: 'Predixon',
          copyright: this.$t('views.SharedModelReport.poweredBy'),
          headerLogo: 'header_logo_predixon.png',
          footerLogo: 'footer_logo_predixon.png',
          loginLogo: 'login_logo_predixon.png',
          headerLogoSize: '45px',
          footerHeight: '100px',
          color: '#212121',
          dark: true
        }
      } else if (window.location.hostname === 'outflink.noisegrasp.com') {
        return {
          name: 'Outflink',
          copyright: this.$t('views.SharedModelReport.poweredBy'),
          headerLogo: 'header_logo_outflink.png',
          footerLogo: 'footer_logo_outflink.png',
          loginLogo: 'login_logo_outflink.png',
          headerLogoSize: '25px',
          footerHeight: '50px',
          color: '#212121',
          dark: true
        }
      } else if (window.location.hostname === 'deloitte.noisegrasp.com') {
        return {
          name: 'Deloitte Marketing Mix Modeling',
          copyright: this.$t('views.SharedModelReport.poweredBy'),
          headerLogo: 'header_logo_deloitte.png',
          footerLogo: 'footer_logo_deloitte.png',
          loginLogo: 'login_logo_deloitte.png',
          headerLogoSize: '50px',
          footerHeight: '100px',
          color: '#212121',
          dark: true
        }
      } else if (window.location.hostname === 'nisum.noisegrasp.com') {
        return {
          name: 'Nisum Marketing Mix Modeling',
          copyright: this.$t('views.SharedModelReport.poweredBy'),
          headerLogo: 'header_logo_nisum.webp',
          footerLogo: 'footer_logo_nisum.webp',
          loginLogo: 'login_logo_nisum.webp',
          headerLogoSize: '50px',
          footerHeight: '100px',
          color: '#212121',
          dark: true
        }
      } else if (window.location.hostname === 'mckinsey.noisegrasp.com') {
        return {
          name: 'McKinsey Marketing Mix Modeling',
          copyright: this.$t('views.SharedModelReport.poweredBy'),
          headerLogo: 'header_logo_mckinsey.png',
          footerLogo: 'footer_logo_mckinsey.png',
          loginLogo: 'login_logo_mckinsey.png',
          headerLogoSize: '50px',
          footerHeight: '100px',
          color: '#212121',
          dark: true
        }
      } else if (window.location.hostname === 'comscore.noisegrasp.com') {
        return {
          name: 'Comscore Marketing Mix Modeling',
          copyright: this.$t('views.SharedModelReport.poweredBy'),
          headerLogo: 'header_logo_comscore.png',
          footerLogo: 'footer_logo_comscore.png',
          loginLogo: 'login_logo_comscore.png',
          headerLogoSize: '50px',
          footerHeight: '100px',
          color: '#E53A2B',
          dark: true
        }
      } else {
        return {
          name: 'NoiseGrasp',
          copyright: this.$t('views.SharedModelReport.allRightsReserved'),
          headerLogo: 'header_logo.png',
          footerLogo: 'logo-ng.png',
          loginLogo: 'login_logo.png',
          headerLogoSize: '25px',
          footerHeight: '50px',
          color: '#212121',
          dark: true
        }
      }
    }
  },
  props: {
    shareId: {
      type: String,
      required: true
    }
  },
  created () {
    document.title = this.$t('views.SharedModelReport.pageTitle')
    this.getSharedModelReport({
      shareId: this.shareId
    })
  },
  components: {
    ModelReportComponent
  }
}
</script>
